import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Theme, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { useSettingsContext } from "../../context/SettingsContext";
import { Setting } from "../../models/Setting";

const useStyles = makeStyles((theme: Theme) => ({
	root: {},
}));

type Props = {
	setOpenModalEditSetting: Function;
	setOpenModalDeleteSetting: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setOpenModalEditSetting,
	setOpenModalDeleteSetting,
	showContextMenu,
}: Props) => {
	const { state, actions } = useSettingsContext();
	const classes = useStyles();

	const columnDefs: ColDef[] = [
		{
			field: "SettingName",
			headerName: "Name",
			minWidth: 180,
			flex: 4,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Value",
			headerName: "Value",
			minWidth: 180,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Description",
			headerName: "Description",
			minWidth: 150,
			flex: 4,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						className={classes.root}
					>
						<Grid
							item
							xs={12}
							md={12}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										actions.setSettingSelected(params?.data as Setting);
										setOpenModalEditSetting(true);
									})();
								}}
							>
								<EditIcon color="primary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={() => {
									(async () => {
										actions.setSettingSelected(params?.data as Setting);
										setOpenModalDeleteSetting(true);
									})();
								}}
							>
								<DeleteIcon color="secondary" fontSize="small" />
							</Button>
							<Button
								size="small"
								style={{ minWidth: 36, padding: 4 }}
								onClick={(e) =>
									showContextMenu(e, params.data, "TableSettings")
								}
							>
								<FormatListBulletedSharpIcon color="action" fontSize="small" />
							</Button>
						</Grid>
					</Grid>
				);
			},
			field: "",
			flex: 1,
			minWidth: 240,
			editable: false,
			autoHeight: false,
			suppressNavigable: true,
		},
	];

	const defaultColDef = useMemo<ColDef>(() => {
		return {
			sortable: true,
			wrapText: true,
			autoHeight: true,
			wrapHeaderText: true,
		};
	}, []);

	return { columnDefs, defaultColDef };
};
